export async function fetchStarter(microFrontendURL) {
    const response = await window.fetch(microFrontendURL, {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'error',
    });
    if (response.status >= 300 && response.status !== 401 && response.status !== 403) {
        return Promise.reject(new Error('Failed to GET ' + microFrontendURL + ' (status: ' + response.status + ')'));
    }
    if (!response.ok) {
        return null;
    }
    const htmlString = await response.text();
    if (!htmlString) {
        return null;
    }
    return htmlString;
}
